import { render, staticRenderFns } from "./TableComponentBuefyManySearches.vue?vue&type=template&id=3b510e5c&scoped=true&"
import script from "./TableComponentBuefyManySearches.vue?vue&type=script&lang=js&"
export * from "./TableComponentBuefyManySearches.vue?vue&type=script&lang=js&"
import style0 from "./TableComponentBuefyManySearches.vue?vue&type=style&index=0&id=3b510e5c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b510e5c",
  null
  
)

export default component.exports